export enum CompletionToneEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    FORMAL = 'FORMAL',
    INFORMAL = 'INFORMAL',
    FUN = 'FUN',
    FRIENDLY = 'FRIENDLY',
    OPTIMISTIC = 'OPTIMISTIC',
    ASSERTIVE = 'ASSERTIVE',
    COOPERATIVE = 'COOPERATIVE',
    SINCERE = 'SINCERE',
    HUMOROUS = 'HUMOROUS',
    URGENT = 'URGENT',
    CUSTOM = 'CUSTOM'
}
